import request from '@/utils/request'

// 去除对象中的空value属性
function filterParams (obj) {
  let newObj = {}
  for (let val in obj) {
    if (obj[val] !== '') newObj[val] = obj[val]
  }
  return newObj
}

// 微信扫码登录
export function socialLoginWeixin (val) {
  return request({
    url: '/api/crm/socialLogin/weixin',
    method: 'get',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 微信用户绑定平台账号
export function openUserWxRegister (val) {
  return request({
    url: '/api/crm/open/user/wxRegister',
    method: 'post',
    params: val
  })
}

// 退出
export function logout (val) {
  return request({
    url: '/api/crm/oauth/logout',
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 业务文档(后台接口)------------------------------------------------
// 根据姓名获取业务列表（模糊查询）
export function getSalesmanByFullName (val) {
  return request({
    url: `/api/crm/admin/salesman/getSalesmanByFullName/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据业务获取平台分页列表
export function getPlatListBySaleman (val) {
  return request({
    url: `/api/crm/admin/salesman/getStoreListBySaleman/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchStoreVo
  })
}
// 获取业务分页列表
export function getSalesmanList (val) {
  return request({
    url: `/api/crm/admin/salesman/getSalesmanList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.salesmanVo
  })
}
// 编辑关联关系(status:0取消关联；1关联)
export function editRelation (val) {
  return request({
    url: '/api/crm/admin/salesman/editRelation',
    method: 'post',
    data: val
  })
}
// 添加业务
export function salesmanPromote (val) {
  return request({
    url: `/api/crm/admin/salesman/promote/${val}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 添加业务
export function salesmanAddSaleman (val) {
  return request({
    url: '/api/crm/admin/salesman/addSaleman',
    method: 'post',
    data: val
  })
}
// 根据uerId获取业务详情
export function getSalemanById (val) {
  return request({
    url: `/api/crm/admin/salesman/getSalemanById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 修改业务信息
export function salesmanUpdate (val) {
  return request({
    url: '/api/crm/admin/salesman/update',
    method: 'put',
    data: val
  })
}
// export
export function salesmanExport (val) {
  return request({
    url: '/api/crm/admin/salesman/export',
    method: 'get',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob'
  })
}

// 地址文档(无需登录)-----------------------------------------------------
// 修改收货信息
export function updateOrderAddress (val) {
  return request({
    url: '/api/crm/address/updateOrderAddress', // 接口
    method: 'post',
    data: val
  })
}
// 查询所有省份
export function addressGetAllProvince () {
  return request({
    url: '/api/crm/open/address/getAllProvince',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据省份code查询城市
export function addressGetCityByProvinceCode (val) {
  return request({
    url: `/api/crm/open/address/getCityByProvinceCode/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据城市id查询区县
export function addressGetCountyByCityId (val) {
  return request({
    url: `/api/crm/open/address/getCountyByCityId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 地址文档（需登录）-----------------------------------
// 删除地址
export function addressDelete (val) {
  return request({
    url: `/api/crm/address/delete/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 设为默认
export function addressSetDefault (val) {
  return request({
    url: `/api/crm/address/setDefault/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 添加地址
export function saveUserAddress (val) {
  return request({
    url: '/api/crm/address/saveUserAddress',
    method: 'post',
    data: val
  })
}
// 根据用户id查询收货地址
export function addressGetAddressByUserId (val) {
  return request({
    url: `/api/crm/address/getAddressByUserId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 根据id查询地址详情
export function addressGetAddressById (val) {
  return request({
    url: `/api/crm/address/getAddressById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据平台id查询地址
export function addressGetAddressByStoreId (val) {
  return request({
    url: `/api/crm/address/getAddressByStoreId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 平台文档（后台接口）------------------------------------------
// 申请平台
export function storeApplyStore (val) {
  return request({
    url: '/api/crm/admin/store/applyStore',
    method: 'post',
    data: val
  })
}
// 平台审核
export function storeAuditStore (val) {
  return request({
    url: '/api/crm/admin/store/auditStore',
    method: 'post',
    data: val
  })
}
// 修改平台信息
export function storeUpdateStore (val) {
  return request({
    url: '/api/crm/admin/store/updateStore',
    method: 'post',
    data: val
  })
}
// 获取平台分页列表
export function storeGetStoreList (val) {
  return request({
    url: `/api/crm/admin/store/getStoreList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.storeVo
  })
}
// export
export function storeExport (val) {
  return request({
    url: '/api/crm/admin/store/export',
    method: 'get',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob'
  })
}

// vip平台文档（后台接口）------------------------------------------
// 获取平台vip信息分页列表
export function storeGetVipStoreList (val) {
  return request({
    url: `/api/crm/admin/vipStore/getStoreList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.storeVo
  })
}
// vip信息导出
export function vipStoreExport (val) {
  return request({
    url: '/api/crm/admin/vipStore/export',
    method: 'get',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob'
  })
}
// 详情
export function vipStoreQueryByStoreId (val) {
  return request({
    url: `/api/crm/admin/vipStore/getById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// VIP平台审核
export function vipStoreAuditStore (val) {
  return request({
    url: '/api/crm/admin/vipStore/audit',
    method: 'post',
    data: val
  })
}
// 修改VIP平台信息
export function vipStoreUpdateStore (val) {
  return request({
    url: '/api/crm/admin/vipStore/update',
    method: 'post',
    data: val
  })
}
// 提现-获取银行信息
export function getByStoreId (val) {
  return request({
    url: `/api/crm/crm/vip-store/getByStoreId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 平台文档（无需登录）-------------------------------------
// 名称可用
export function storeUsable (val) {
  return request({
    url: '/api/crm/open/store/usable',
    method: 'post',
    params: val
  })
}
// 检查重复
export function checkStoreCode (val) {
  return request({
    url: `/api/crm/open/store/checkStoreCode/${val.storeCode}/${val.id}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 平台文档（需登录）-------------------------------------
// 平台详情
export function storeQueryByStoreId (val) {
  return request({
    url: `/api/crm/store/queryByStoreId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 获取待审核平台数量
export function storeGetPendingNum (val) {
  return request({
    url: '/api/crm/admin/store/getPendingNum',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 验证平台
export function storeQueryByStoreCode (val) {
  return request({
    url: `/api/crm/store/queryByStoreCode/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据平台号获取平台(模糊查询)
export function storeQueryListByCode (val) {
  return request({
    url: `/api/crm/store/queryListByCode/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据平台名称获取平台(模糊查询)
export function storeQueryListByName (val) {
  return request({
    url: `/api/crm/store/queryListByName/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 平台类型文档（需登录）----------------------------------------
// 获取平台类型列表
export function storeTypeGetStoreTypeList () {
  return request({
    url: '/api/crm/storeType/getStoreTypeList',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 菜单文档(后台接口)-----------------------------------------
// 设置特殊权限
export function menuUpdateSpecial (val) {
  return request({
    url: `/api/crm/admin/menu/updateSpecial/${val.menuId}/${val.isSpecial}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 递归删除菜单（逻辑删除）
export function menuRemoveMenu (val) {
  return request({
    url: `/api/crm/admin/menu/removeMenu/${val}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 修改菜单
export function menuUpdate (val) {
  return request({
    url: '/api/crm/admin/menu/update',
    method: 'put',
    data: val
  })
}
// 新增菜单
export function menuAddMenu (val) {
  return request({
    url: '/api/crm/admin/menu/addMenu',
    method: 'post',
    data: val
  })
}

// 菜单文档（需登录）----------------------------------------------
// 根据角色获取菜单
export function getMenuByRole (val) {
  return request({
    url: `/api/crm/menu/getMenuByRole/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据ID获取菜单
export function getMenuById (val) {
  return request({
    url: `/api/crm/menu/getMenuById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 查询所有菜单
export function getAllMenu () {
  return request({
    url: '/api/crm/admin/menu/getAllMenu',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据用户ID获取权限菜单
export function getMenuByUserId (val) {
  return request({
    url: `/api/crm/menu/getMenuByUserId/${val}/1`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据token获取用户权限集合
export function selectPermsByToken (val) {
  return request({
    url: '/api/crm/menu/selectPermsByToken',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 角色文档（需登录）---------------------------------------
// 获取角色详情
export function getRoleById (val) {
  return request({
    url: `/api/crm/role/get/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 角色文档(后台接口)-------------------------------------------
// 修改角色状态
export function roleUpdateStatus (val) {
  return request({
    url: `/api/crm/admin/role/updateStatus/${val.roleId}/${val.status}`,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增角色
export function roleSave (val) {
  return request({
    url: '/api/crm/admin/role/save',
    method: 'post',
    data: val
  })
}
// 修改角色
export function roleUpdate (val) {
  return request({
    url: '/api/crm/admin/role/update',
    method: 'put',
    data: val
  })
}
// 根据角色获取用户分页列表
export function roleGetUserListByRole (val) {
  return request({
    url: `/api/crm/admin/role/getUserListByRole/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.searchUserByRoleVo
  })
}
// 获取角色分页列表
export function roleGetRoleList (val) {
  return request({
    url: `/api/crm/admin/role/associate/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.roleVo
  })
}
// 获取所有角色名称
export function getRoleName (val) {
  return request({
    url: '/api/crm/admin/role/getRoleName',
    method: 'post',
    data: val
  })
}

// 客户投诉文档(后台接口)-------------------------------------
// 获取投诉详情
export function complaintGetById (val) {
  return request({
    url: `/api/crm/admin/complaints/getById/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 投诉处理
export function complaintsHandleComplaints (val) {
  return request({
    url: '/api/crm/admin/complaints/handleComplaints',
    method: 'post',
    data: val
  })
}
// 获取客户投诉分页列表
export function complaintsGetComplaintsList (val) {
  return request({
    url: `/api/crm/admin/complaints/getComplaintsList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.complaintsVo
  })
}
// 新增投诉类型
export function addComplaintsType (val) {
  return request({
    url: '/api/crm/admin/complaints/addComplaintsType',
    method: 'post',
    params: val
  })
}
// 删除投诉类型
export function deleteComplaintsType (id) {
  return request({
    url: `/api/crm/admin/complaints/deleteComplaintsType/${id}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 客户投诉文档（需登录）-----------------------------------------------
// 获取待处理投诉数量
export function complaintsGetPendingNum (val) {
  return request({
    url: '/api/crm/admin/complaints/getPendingNum',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 投诉类型列表
export function getComplaintsTypeList (val) {
  return request({
    url: '/api/crm/complaints/getComplaintsTypeList',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 用户文档（后台接口）-------------------------------------------
// 根据姓名获取用户列表
export function getAllUsersByFullName (val) {
  return request({
    url: `/api/crm/admin/user/getAllUsersByFullName/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据用户名获取用户列表
export function getAllUsersByUserName (val) {
  return request({
    url: `/api/crm/admin/user/getAllUsersByUserName/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 添加成员
export function userAddAdmin (val) {
  return request({
    url: '/api/crm/admin/user/addAdmin',
    method: 'post',
    data: val
  })
}
// 修改用户信息
export function userUpdate (val) {
  return request({
    url: '/api/crm/admin/user/update',
    method: 'put',
    data: val
  })
}
// 获取用户分页列表
export function userGetUserList (val) {
  return request({
    url: `/api/crm/admin/user/getUserList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.userVo
  })
}
// 角色设置
export function userDoAssign (val) {
  return request({
    url: '/api/crm/admin/user/doAssign',
    method: 'post',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据姓名获取管理员列表
export function getAdminByFullName (val) {
  return request({
    url: `/api/crm/admin/user/getAdminByFullName/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 获取管理员分页列表
export function userGetAdminList (val) {
  return request({
    url: `/api/crm/admin/user/getAdminList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.adminVo
  })
}
// 删除成员
export function userRemoveAdmin (val) {
  return request({
    url: `/api/crm/admin/user/removeAdmin/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 用户文档（无需登录）---------------------------------------------
// 找回密码
export function userFindPwd (val) {
  return request({
    url: '/api/crm/open/user/findPwd',
    method: 'post',
    data: val
  })
}
// 客户信息列表获取用户类型
export function userGetUserType (val) {
  return request({
    url: '/api/crm/open/user/getUserType',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 获取用户类型列表
export function userGetUserTypeList (val) {
  return request({
    url: `/api/crm/open/user/getUserTypeList/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 用户文档（需登录）----------------------------------------------
// 根据uerId获取用户详情
export function userQueryByUserId (val) {
  return request({
    url: `/api/crm/user/queryByUserId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据token获取用户信息
export function useCurrentUser () {
  return request({
    url: '/api/crm/user/currentUser',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 检查手机号是否已注册
export function checkPhone (phone, val) {
  return request({
    url: `/api/crm/user/checkPhone/${phone}`,
    method: 'get',
    params: { salesmanManage: val },
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 短信文档--------------------------------------------------------------------------
// 校验短信验证码
export function checkCode (val) {
  return request({
    url: `/api/crm/code/sms/checkCode/${val.phone}/${val.code}/${val.type}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 发送短信验证码
export function codeSms (phone, type) {
  return request({
    url: `/api/crm/code/sms/${phone}/${type}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 修改地址
export function updateAddress (val) {
  return request({
    url: '/api/crm/address/update',
    method: 'put',
    data: val,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 根据id查询地址
export function getAddressByUserId (val) {
  return request({
    url: `/api/crm/address/getAddressByUserId/${val}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 查询所有省份
export function getAllProvince (val) {
  return request({
    url: '/api/crm/open/address/getAllProvince',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// export
export function financeReport (val) {
  return request({
    url: '/api/finance/admin/fapiao/report',
    method: 'post',
    data: filterParams(val),
    responseType: 'blob'
  })
}

// 根据userId获取用户信息
export function queryByUserId (val) {
  return request({
    url: `/api/crm/user/getUserBasicInfoByUserId/${val}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// APP ---消息
// 产品上新/优惠活动列表查询
export function getCouponMsgList (val) {
  return request({
    url: '/api/crm/app-push/getCouponMsgList',
    method: 'post',
    data: val
  })
}
// 新增产品上新
export function sendUpProductMsg (val) {
  return request({
    url: '/api/crm/app-push/sendUpProductMsg',
    method: 'post',
    data: val
  })
}
// 编辑产品上新
export function editUpProductMsg (val) {
  return request({
    url: '/api/crm/app-push/editUpProductMsg',
    method: 'post',
    data: val
  })
}
// 删除产品上新
export function delUpProductMsg (val) {
  return request({
    url: `/api/crm/app-push/delUpProductMsg?id=${val}`,
    method: 'post'
  })
}
// 版本升级列表
export function getlistByMethod (val) {
  return request({
    url: `/api/crm/app-push-record/listByMethod?pageNum=${val.pageNum}&pageSize=${val.pageSize}&method=${val.Vo.method}`,
    method: 'post'
  })
}
// 新增版本升级
export function addAppPushRecord (val) {
  return request({
    url: '/api/crm/app-push-record/add',
    method: 'post',
    data: val
  })
}
// 修改版本升级
export function editInfoAppPushRecord (val) {
  return request({
    url: '/api/crm/app-push-record/editInfo',
    method: 'post',
    data: val
  })
}
// 新增app系统推送消息后台界面 历史版本下拉框接口
export function getHistoryVersion (val) {
  return request({
    url: `/api/crm/app-push-record/getHistoryVersion/${val}`,
    method: 'get'
  })
}
// 客服 type 值：PLATFROM_INFO查询平台信息
// CUSTOMER_QUICK_TYPE 客服快捷语类型
export function getInfoByType (val = 'CUSTOMER_QUICK_TYPE ') {
  return request({
    url: `/api/crm/app-dictionary/getInfoByType?type=${val}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据用户绑定客服信息
export function bindCustomer (val) {
  return request({
    url: '/api/crm/app-customer-info/bind/customer',
    method: 'post',
    data: val
  })
}
// 模糊查询快捷语列表
export function queryByQuickMsg (val) {
  return request({
    url: `/api/crm/app-customer-quick-msg/queryByQuickMsg?context=${val.context}&customerId=${val.customerId}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 新增APP客服信息快捷短句
export function quickMsgAdd (val) {
  return request({
    url: '/api/crm/app-customer-quick-msg/save/quickMsg',
    method: 'post',
    data: val
  })
}
// 编辑APP客服信息快捷短句
export function quickMsgEdit (val) {
  return request({
    url: '/api/crm/app-customer-quick-msg/editInfoById',
    method: 'post',
    data: val
  })
}
export function deleteInfoById (id) {
  return request({
    url: `/api/crm/app-customer-quick-msg/deleteInfoById?id=${id}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function quickMsgList (id) {
  return request({
    url: `/api/crm/app-customer-quick-msg/list/quickMsg?customerId=${id}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更换手机号
export function resetPhone (val) {
  return request({
    url: '/api/crm/admin/store/resetPhone',
    method: 'post',
    data: val
  })
}
// 获取店铺信息分页列表
export function getMembershipList (val) {
  return request({
    url: `/api/crm/images/membership/getMembershipList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.storeVo
  })
}
// 详情
export function queryMembershipById (id) {
  return request({
    url: `/api/crm/images/membership/queryById/${id}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 获取AI分片明细列表
export function getRecordsList (val) {
  return request({
    url: `/api/crm/split/images/getRecordsList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.storeVo
  })
}
// 获取AI分片店铺信息
export function getSplitImagesList (val) {
  return request({
    url: `/api/crm/split/images/getSplitImagesList/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.storeVo
  })
}
// 未归类照片详情
export function queryByRecordsId (id) {
  return request({
    url: `/api/crm/split/images/queryByRecordsId/${id}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 查询所有套餐名称列表
export function getMemberShipList (val) {
  return request({
    url: `/api/crm/crm-video-season-membership-plan/list?pageSize=${val.pageSize}&pageNum=${val.pageNum}&name=${val.name}`,
    method: 'post'
  })
}
// 新增套餐
export function membershipPlanAdd (val) {
  return request({
    url: '/api/crm/crm-video-season-membership-plan/add',
    method: 'post',
    data: val
  })
}
// 更改是否推荐
export function updateRecommend (id) {
  return request({
    url: `/api/crm/crm-video-season-membership-plan/updateRecommend/${id}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 更改是否显示
export function updateShow (id) {
  return request({
    url: `/api/crm/crm-video-season-membership-plan/updateShow/${id}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 根据id查详情
export function membershipPlanId (id) {
  return request({
    url: `/api/crm/crm-video-season-membership-plan/${id}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 获取店铺信息分页列表
export function getMemberShipOrderList (val) {
  return request({
    url: `/api/crm/crm-video-season-membership-order/list?pageSize=${val.pageSize}&pageNum=${val.pageNum}`,
    method: 'post',
    data: val.storeVo
  })
}
// 配置数据
export function saveOrUpdateWxConfig (val) {
  return request({
    url: '/api/crm/images/membership/saveOrUpdateWxConfig',
    method: 'post',
    data: val
  })
}
// 根据storeId查询小程序数据
export function queryWxConfigByStoreId (id) {
  return request({
    url: `/api/crm/images/membership/queryWxConfigByStoreId/${id}`, // 接口
    method: 'get', // 请求方式
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
export function bannerSave (val) {
  return request({
    url: '/api/crm/open/video/season/login/banner/save',
    method: 'post',
    data: val
  })
}
export function getBannerDetail (val) {
  return request({
    url: '/api/crm/open/video/season/login/banner/getAllBanner',
    method: 'post',
    data: val
  })
}

export function batchRemove (val) {
  return request({
    url: '/api/crm/open/video/season/login/banner/batchRemove',
    method: 'delete',
    data: val
  })
}
// 影像季
// 获取小程序码
export function getQRCode (val) {
  return request({
    url: '/api/crm/open/unt/wx/qrcode/getQRCode',
    method: 'post',
    data: val
  })
}
// 保存scene
export function qrcodeAddScene (scene) {
  return request({
    url: `/api/crm/open/unt/wx/qrcode/addScene/${scene}`,
    method: 'get'
  })
}
// 获取店铺信息
export function getMembershipListForQuery (val) {
  return request({
    url: '/api/crm/images/membership/getMembershipListForQuery',
    method: 'post',
    data: val
  })
}
// 新增会员申请记录
export function videoMembership (val) {
  return request({
    url: '/api/crm/crm-video-season-apply-membership', // 接口
    method: 'post', // 请求方式
    data: val
  })
}
// 查询所有套餐名称列表
export function getNameList (scene) {
  return request({
    url: '/api/crm/crm-video-season-membership-plan/getNameList',
    method: 'get'
  })
}
// 会员申请详情
export function applyMembership (id) {
  return request({
    url: `/api/crm/crm-video-season-apply-membership/${id}`,
    method: 'get'
  })
}
// 获取店铺信息分页列表
export function getApplyMembershipList (val) {
  return request({
    url: `/api/crm/crm-video-season-apply-membership/list?page=${val.pageNum}&pageCount=${val.pageSize}`,
    method: 'post',
    data: val.storeVo
  })
}
// 会员审核
export function videoMembershipAudit (val) {
  return request({
    url: `/api/crm/crm-video-season-apply-membership/audit?id=${val.id}&approve=${val.approve}&refuseReason=${val.refuseReason}`, // 接口
    method: 'post', // 请求方式
    data: {}
  })
}
// 店铺折扣
// 申请店铺折扣
export function applyDiscount (val) {
  return request({
    url: '/api/crm/crm-store-apply-discount', // 接口
    method: 'post', // 请求方式
    data: val
  })
}
// 列表查询
export function applyDiscountList (val) {
  return request({
    url: '/api/crm/crm-store-apply-discount/list',
    method: 'post',
    data: val.storeVo
  })
}
// 通过店铺id查看店铺折扣信息
export function membership (id) {
  return request({
    url: `/api/crm/crm-store-apply-discount/${id}`,
    method: 'get'
  })
}
// 修改
export function applyDiscountUpdate (val) {
  return request({
    url: '/api/crm/crm-store-apply-discount',
    method: 'put',
    data: val
  })
}
// 审核
export function applyDiscountAudit (val) {
  return request({
    url: '/api/crm/crm-store-apply-discount/audit',
    method: 'get',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 删除
export function applyDiscountDelete (id) {
  return request({
    url: `/api/crm/crm-store-apply-discount/${id}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/// 积分规则----
// 查询积分规则
export function getPointRules (attachType) {
  return request({
    url: `/api/crm/points/rules/getRules/${attachType}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 设置积分规则
export function setPointRules (val) {
  return request({
    url: '/api/crm/points/rules/createOrUpdate',
    method: 'put',
    data: val
  })
}

export function changePoint (val) {
  return request({
    url: '/api/crm/points/store/pointsChange',
    method: 'put',
    data: val
  })
}

export function getPointList (val) {
  return request({
    url: `/api/crm/crm/points/store/change/flow/getPointsStoreChangeFlowPage/${val.pageNum}/${val.pageSize}`,
    method: 'post', // 请求方式
    data: val
  })
}

export function getUserPoints (storeId, attachType) {
  return request({
    url: `/api/crm/points/store/getPointsStore/${storeId}/${attachType}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export function pointExport (val) {
  return request({
    url: '/api/crm/crm/points/store/change/flow/export', // 接口
    method: 'post', // 请求方式
    data: val,
    responseType: 'blob'
  })
}
// --------业务主管信息
// 列表
export function getSalesmanManegerList (val) {
  return request({
    url: `/api/crm/admin/salesmanManager/getSalesmanManegerList/${val.pageNum}/${val.pageSize}`,
    method: 'post', // 请求方式
    data: val.salesmanVo
  })
}
// 添加业务主管
export function addSalemanManager (val) {
  return request({
    url: '/api/crm/admin/salesmanManager/addSalemanManager',
    method: 'post',
    data: val
  })
}
// 添加业务主管(已存在)
export function salesmanManager (val) {
  return request({
    url: `/api/crm/admin/salesmanManager/salesmanManager/${val}`,
    method: 'post',
    data: val
  })
}
// 修改业务主管信息
export function salesmanManagerUpdate (val) {
  return request({
    url: '/api/crm/admin/salesmanManager/update',
    method: 'put',
    data: val
  })
}
// 根据业务主管获取下级关联业务分页列表
export function getSalesListBySalesmanManagerId (val) {
  return request({
    url: `/api/crm/admin/salesmanManager/getSalesListBySalesmanManagerId/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.salesmanVo
  })
}
// 根据业务主管获取下级未关联业务分页列表
export function getNotAssesSalesListBySalesmanManagerId (val) {
  return request({
    url: `/api/crm/admin/salesmanManager/getNotAssesSalesListBySalesmanManagerId/${val.pageNum}/${val.pageSize}`,
    method: 'post',
    data: val.salesmanVo
  })
}
// 编辑关联关系(status:0取消关联；1关联)
export function editSalesmanManagerRelation (val) {
  return request({
    url: '/api/crm/admin/salesmanManager/editSalesmanManagerRelation',
    method: 'post',
    data: val
  })
}
// export
export function salesmanManagerExport (val) {
  return request({
    url: '/api/crm/admin/salesmanManager/export',
    method: 'get',
    params: val,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob'
  })
}
